import { render } from "./BuySection.vue?vue&type=template&id=0794770d"
import script from "./BuySection.vue?vue&type=script&lang=js"
export * from "./BuySection.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__